import { MdOutlineViewSidebar } from "react-icons/md";
import { BUTTON_STYLES, ICON_SIZES } from "../helpers/constants";
import useMobile from "./useMobile";
import clsx from "clsx";
import userPreferencesStore from "../store/userPreferences";
import { useTranslation } from "react-i18next";
import { EButtonKind } from "src/components/Button/ButtonTypes";

export default function useGeneralOptionsDropdownMenu() {
  const { isMobile } = useMobile();
  const { rightPanelIsVisible, setRightPanelIsVisible } =
    userPreferencesStore();
  const { t } = useTranslation();

  return {
    className: isMobile ? BUTTON_STYLES.HEADING : "",
    icon: rightPanelIsVisible ? (
      <MdOutlineViewSidebar
        size={ICON_SIZES.MD}
        className={clsx(["text-red-500", "dark:text-purple-500"])}
      />
    ) : (
      <MdOutlineViewSidebar size={ICON_SIZES.MD} />
    ),
    tooltip: t("shared.lateral_panel"),
    kind: EButtonKind.NORMAL,
    onClick: () => {
      setRightPanelIsVisible(!rightPanelIsVisible);
    },
    hide: isMobile,
  };
}
